import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import IconAmenityAttendant from '@spothero/icons/amenity-attendant';
import IconClock from '@spothero/icons/clock';

export const SAFETY_AMENITIES = {
    attendant: {
        icon: IconAmenityAttendant,
    },
    'time-24-7': {
        icon: IconClock,
        name: '24/7 Access',
    },
};
export const SAFETY_AMENITIES_SLUGS = Object.keys(SAFETY_AMENITIES);

const SafetyAmenities = ({amenities}) => {
    const safetyAmenities = amenities.filter(amenity =>
        Boolean(
            SAFETY_AMENITIES_SLUGS.find(
                safetyAmenity => amenity.slug === safetyAmenity
            )
        )
    );

    return (
        <div className="SafetyAmenities">
            <h4 className="subtitle">Safety Amenities</h4>
            <ul className="SafetyAmenities-list">
                {safetyAmenities.map((amenity, i) => {
                    const amenityOverride = SAFETY_AMENITIES[amenity.slug];
                    const Icon = amenityOverride.icon;
                    const displayName = get(
                        amenityOverride,
                        'name',
                        amenity.name
                    );

                    return (
                        <li key={i}>
                            <span className="SafetyAmenities-icon">
                                <Icon />
                            </span>
                            <span className="SafetyAmenities-list-item-content">
                                {displayName}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

SafetyAmenities.propTypes = {
    amenities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SafetyAmenities;
